import React, { useContext } from "react";
import {
  TodoCounter,
  TodoItem,
  TodoSearch,
  TodoList,
  CreateTodoButton,
  TodoForm,
  Header,
} from "../components";
import { Modal } from "../Modal";
import { TodoContext } from "../TodoContext";

const AppUI = () => {
  const {
    error,
    loading,
    searchTodos,
    completeTodo,
    deleteTodo,
    openModal,
    setOpenModal,
  } = useContext(TodoContext);

  return (
    <div>
      <Header />
      <TodoCounter />
      <TodoSearch />

      <TodoList>
        {error && <p>Hubo un error...</p>}
        {loading && <p>Estamos cargando...</p>}
        {!loading && !searchTodos.length && (
          <p>No hay tareas. Crea la primera!</p>
        )}
        {searchTodos.map((todo) => (
          <TodoItem
            key={todo.text}
            text={todo.text}
            completed={todo.completed}
            onComplete={() => completeTodo(todo.text)}
            onDelete={() => deleteTodo(todo.text)}
          />
        ))}
      </TodoList>
      {!!openModal && (
        <Modal>
          <TodoForm />
        </Modal>
      )}

      <CreateTodoButton setOpenModal={setOpenModal} />
    </div>
  );
};

export default AppUI;
